const COLUMN_PARTS = [
  { example: "RS", column: "Prefix" },
  { example: "[PE-LLD]", column: "Base column" },
  { example: "PCR50", column: "Recycle column" },
  { example: "GF30", column: "Fillers column" },
  { example: "UV", column: "Additives column" },
  { example: "NC", column: "Color column" },
  { example: "/V2", column: "Suffix column" },
];

const STEPS = [
  {
    title: "Read the row.",
    text: "Every column in the file is read by its header name: Supplier Code, Supplier, Tradename Code, Supplier Tradename, Processing Application, Standard Applied, RS Designation, Reads As, Base, Hardness, Fillers, Additives, Color, Recycle, Suffix and Source. Supplier Code, Tradename Code and Hardness can be empty.",
  },
  {
    title: "Find the base.",
    text: "With brackets, the base is what's inside them: RS-[PE-HD]-NC gives PE-HD. Without brackets, the Base column says where the base ends. The Base column must name the same base.",
  },
  {
    title: "Match every other part to its column.",
    text: "Each part after the base must appear in its column, and each column value must appear in the designation. A part in one place but not the other is a problem, for example \"Color column says BK but the designation says NC\".",
  },
  {
    title: "Check the suffix and hardness.",
    text: "The suffix is anything after a / at the end, such as V2. Hardness and suffix are free text: they never need approval, but they must match their columns.",
  },
  {
    title: "Check every code is approved.",
    text: "The base and every part code must be in the code registry. A new code needs its Reads As in the file: the Reads As column lists one part per part of the designation, so \"LLDPE, UV-stabilized, natural\" gives PE-LLD, UV and NC their Reads As. A hardness part such as \"55 Shore D\" can be in the Reads As or left out; it is skipped either way. A new code with no Reads As is a problem to fix in the file.",
  },
  {
    title: "Save.",
    text: "The supplier and tradename are matched to an existing grade or a new one is created, the designation is stored once with brackets around the base, and the grade is linked to it. Rows waiting on new codes save automatically once their codes are approved.",
  },
];

export function HowARowIsRead() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap gap-1.5" aria-label="Spreadsheet columns that make up a designation">
        {COLUMN_PARTS.map((part) => (
          <div key={part.column} className="border border-rs-jet rounded-[5px] px-2.5 py-1.5 flex flex-col">
            <code className="text-white text-[13px]">{part.example}</code>
            <small className="text-rs-light-gray text-[11px]">{part.column}</small>
          </div>
        ))}
      </div>
      <ol className="m-0 pl-5 flex flex-col gap-2.5 text-rs-light-gray text-[13px] leading-relaxed max-w-[78ch]">
        {STEPS.map((step) => (
          <li key={step.title}>
            <b className="text-white font-semibold">{step.title}</b> {step.text}
          </li>
        ))}
      </ol>
    </div>
  );
}
